import axios from 'axios'

axios.defaults.headers = {
  'Content-Type': 'application/json'
}

export default {

  fetchNews (newsSource) {
    return axios.get('https://newsapi.org/v2/top-headlines', {
      params: {
        sources: newsSource,
        apiKey: '251fdf3bb4124ca4838f191d3896b3a8',
        format: 'json'
      }
    })
      .then(response => {
        return response.data
      })
  },
  fetchStockQuotes (tickerList) {
    return axios.get('https://cloud.iexapis.com/stable/stock/market/batch', {
      params: {
        symbols: tickerList,
        types: 'quote',
        token: 'pk_8dfadce5bfc34b44b4bce5f4fb6a5381'
      }
    })
      .then(response => {
        return response.data
      })
  },
  fetchCryptoQuote (ticker) {
    //btcusd, ethusd
    var tickerUrl = 'https://cloud.iexapis.com/stable/crypto/'  + ticker + '/price'
    return axios.get(tickerUrl, {
      params: {
        token: 'pk_8dfadce5bfc34b44b4bce5f4fb6a5381'
      }
    })
      .then(response => {
        return response.data
      })
  },
  fetchWeather (cityIds = ['5373763','5323163','5368361','5327684']) {
    // Accept array or comma-separated string; make individual requests per city id
    const ids = Array.isArray(cityIds) ? cityIds : String(cityIds).split(',').map(s => s.trim())
    const key = process.env.VUE_APP_OPENWEATHER_API_KEY || 'b9912ebaa44210dbb82f70ed6de9f0dd'

    const requests = ids.map(id =>
      axios.get('https://api.openweathermap.org/data/2.5/weather', {
        params: {
          id,
          units: 'imperial',
          appid: key,
          format: 'json'
        }
      }).then(resp => resp.data)
    )

    return Promise.all(requests)
  },
  fetchDataFile (dataSource) {
    // environment variable not getting changed
    //var dataUrl = process.env.VUE_APP_API_ENDPOINT + dataSource
    var dataUrl = '';
    if (process.env.NODE_ENV == 'production') {
      dataUrl = 'https://launcher.evanyamoto.com/data/' + dataSource
    }
    else {
      dataUrl = 'http://localhost:8080/data/' + dataSource
    }
    
    return axios.get(dataUrl, {
      params: {
        format: 'json'
      }
    })
    .then(response => {
      return response.data
    })
  }
}
